import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { STORAGE_KEYS } from '../enums/commission';
import { environment } from '../../environments/environment';
import { TokenDTO } from '../models/user/token-dto';

export class HTTPUtilsSSO {
  constructor(private http: HttpClient) {}

  public getIDToken(): Observable<{ [key: string]: any }> {
    return this.http.post<{ [key: string]: any }>(
      environment.ID_TOKEN_URL,
      environment.IDTOKEN,
      {
        headers: {
          'Content-Type': 'application/x-amz-json-1.1',
          'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth',
        },
      }
    );
  }

  public getAccessToken(code?: string, state?: string): Observable<{ [key: string]: any }> {
    let body = new URLSearchParams();
    body.set('grant_type', 'client_credentials');
    
    const headers: { [key: string]: string } = {
      'Content-Type': 'application/x-www-form-urlencoded',
      CustomHeader: 'Basic Z2EtY2xpZW50OmdhLXNlY3JldA==',
      Authorization: `Bearer ${
        localStorage.getItem(STORAGE_KEYS.ID_TOKEN) ?? ''
      }`,
    };

    // Add code and state as headers if provided
    if (code) {
      headers['code'] = code;
    }
    if (state) {
      headers['state'] = state;
    }

    return this.http.post(environment.ACCESS_TOKEN_URL, body.toString(), {
      headers,
      withCredentials: true,
    });
  }

  public getLoginUrl(): Observable<TokenDTO> {
    return this.http.get<TokenDTO>(environment.APP_LOGIN, {
        headers: {
          Authorization: `Bearer ${
            localStorage.getItem(STORAGE_KEYS.ID_TOKEN) ?? ''
          }`
        },
      });
  }


  public logoutUser(code: string | null): Observable<any> {
    const headers: { [key: string]: string } = {
      Authorization: `Bearer ${localStorage.getItem(STORAGE_KEYS.ID_TOKEN) ?? ''}`,
      CustomHeader: `Bearer ${localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN) ?? ''}`,
    };
    if (code) {
      headers['code'] = code;
    }
    return this.http.get(environment.APP_LOGOUT, {
      headers,
      withCredentials: true,
    });
  }
}
